export default "__VITE_ASSET__eZu2PJoO__"